import httpClient from "./httpClient";
import type { ApiResponse } from "../types/api";

export interface UserHelpFile {
  title?: string;
  filename?: string;
  mime?: string;
  extension?: string;
  size?: number;
  filedata?: string;
  preview?: {
    type?: string;
    rows?: string[][];
    lines?: string[];
  } | null;
}

export default class UserHelpApi {
  static getFile(languageKey: string): Promise<ApiResponse<UserHelpFile>> {
    return httpClient
      .get(API_URL + "/user_help/file", {
        params: { lang: languageKey },
      })
      .then((response) => response.data);
  }
}
